import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * useBlacklistCheck — debounced early-detect a barred customer as they type
 * their email / phone into a booking form. Returns `{ blocked, reason,
 * checking }`. The parent shows a friendly banner + disables the Continue
 * button so a barred client doesn't waste 5 minutes filling the whole
 * contract just to be rejected at submit time.
 *
 * We debounce 700ms so we're not hitting the endpoint on every keystroke,
 * and we only fire once either identifier is at least somewhat complete
 * (email contains "@", or phone has 7+ digits).
 */
export function useBlacklistCheck(email, phone) {
  const [state, setState] = useState({ blocked: false, reason: null, checking: false });
  useEffect(() => {
    const e = (email || "").trim().toLowerCase();
    const p = (phone || "").replace(/\D/g, "");
    const emailReady = e.includes("@") && e.split("@")[1]?.includes(".");
    const phoneReady = p.length >= 7;
    if (!emailReady && !phoneReady) {
      setState({ blocked: false, reason: null, checking: false });
      return undefined;
    }
    let cancelled = false;
    setState((s) => ({ ...s, checking: true }));
    const t = setTimeout(() => {
      api.post("/public/blacklist-check", {
        email: emailReady ? e : null,
        phone: phoneReady ? p : null,
      }).then((r) => {
        if (cancelled) return;
        setState({
          blocked: !!r.data?.blocked,
          reason: r.data?.reason || null,
          checking: false,
        });
      }).catch(() => {
        if (!cancelled) setState({ blocked: false, reason: null, checking: false });
      });
    }, 700);
    return () => { cancelled = true; clearTimeout(t); };
  }, [email, phone]);
  return state;
}
